export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13101.c4b274eb.jpg";